import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, path = "/", image, jsonLd }) {
  const fullTitle = title ? `${title} — SECQRE` : "SECQRE — Private Vehicle Contact. Powered by QR.";
  const desc = description || "SECQRE turns your windshield into a private contact line. Masked calls, instant alerts, zero phone number exposure.";
  const url = `https://secqre.com${path}`;
  const ogImage = image || "https://customer-assets.emergentagent.com/job_tech-secqre/artifacts/3vobya5t_WhatsApp%20Image%202026-05-18%20at%207.57.38%20PM.jpeg";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
